export const formattedSubscriberSortOptions = [
    { value: "", text: "Date" },
    { value: "loyalty_DESC", text: "Loyalty" }
];

export const DEFAULT_SUBSCRIBERS__SEARCH_PARAMS = {
    ORDERBY: formattedSubscriberSortOptions[0].value
};
